var _desc, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurprise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.75 -0.75 16 16",
    stroke: "currentColor",
    "aria-hidden": "true",
    id: "Gift--Streamline-Heroicons-Outline",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Gift Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.6875 6.796875v4.984375a0.90625 0.90625 0 0 1 -0.90625 0.90625H3.171875a0.90625 0.90625 0 0 1 -0.90625 -0.90625v-4.984375M7.25 2.9453125A1.5859375 1.5859375 0 1 0 5.6640625 4.53125H7.25m0 -1.5859375V4.53125m0 -1.5859375A1.5859375 1.5859375 0 1 1 8.8359375 4.53125H7.25m0 0V12.6875m-5.2109375 -5.890625h10.875c0.37518749999999995 0 0.6796875 -0.3045 0.6796875 -0.6796875v-0.90625c0 -0.37518749999999995 -0.3045 -0.6796875 -0.6796875 -0.6796875h-10.875c-0.37518749999999995 0 -0.6796875 0.3045 -0.6796875 0.6796875v0.90625c0 0.37518749999999995 0.3045 0.6796875 0.6796875 0.6796875Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurprise);
export default __webpack_public_path__ + "static/media/surprise.bb6e62a628d90c0b0b8ab577514a9fe0.svg";
export { ForwardRef as ReactComponent };